/** True when the meeting's start time is now or in the past. Both sides are absolute
 *  instants, so this is timezone-agnostic. */
export const hasMeetingStarted = (startDateTime: Date | string): boolean =>
	new Date(startDateTime).getTime() <= Date.now();
